// extracted by mini-css-extract-plugin
export default {"fieldwork":"ContactFormBlock_fieldwork__pzA-B","montserrat":"ContactFormBlock_montserrat__nbnvW","dark":"ContactFormBlock_dark__AN6R2","light":"ContactFormBlock_light__BJ7zq"};